import { isCdt, isPreProd, isProd } from "./constant";
export const product_id = "1003";

const ACCOUNT_BASE_URL = isProd
  ? "https://api.maersk.com/atom-commons/api/"
  : isPreProd
  ? "https://api-stage.maersk.com/atom-commons/api/"
  : isCdt
  ? "https://api-cdt.maersk.com/atom-commons/api/"
  : "https://atom-commons-service.dev.maersk-digital.net/api/";

const DISPUTE_BASE_URL = isProd
  ? "https://api.maersk.com/disputes/api/"
  : isPreProd
  ? "https://api-stage.maersk.com/disputes/api/"
  : isCdt
  ? "https://api-cdt.maersk.com/disputes/api/"
  : "https://ohp-dispute-service.dev.maersk-digital.net/api/";

const DISPUTE_BASE_LOCATION = isProd
  ? "https://api.maersk.com/synergy/reference-data/geography/locations"
  : isPreProd
  ? "https://api-stage.maersk.com/synergy/reference-data/geography/locations"
  : isCdt
  ? "https://api-cdt.maersk.com/synergy/reference-data/geography/locations"
  : "https://ohp-dispute-service.dev.maersk-digital.net/synergy/reference-data/geography/locations";

const SFDC_BASE_URL = isProd
  ? "https://api.maersk.com/disputes-sfdc/api/"
  : isPreProd
  ? "https://api-stage.maersk.com/disputes-sfdc/api/"
  : isCdt
  ? "https://api-cdt.maersk.com/disputes-sfdc/api/"
  : "https://ohp-sfdc-service.dev.maersk-digital.net/api/";

const DATA_BASE_URL = isProd
  ? "https://api.maersk.com/disputes-data/api/"
  : isPreProd
  ? "https://api-stage.maersk.com/disputes-data/api/"
  : isCdt
  ? "https://api-cdt.maersk.com/disputes-data/api/"
  : "https://ohp-data-service.dev.maersk-digital.net/api/";

const GAM_BASE_URL = isProd
  ? "https://api.maersk.com/gamv2/api/"
  : isPreProd
  ? "https://api-stage.maersk.com/gamv2/api/"
  : isCdt
  ? "https://api-cdt.maersk.com/gamv2/api/"
  : "https://gam-api-services-v2.dev.maersk-digital.net/api/";

const ATOM_WORKFLOW = isProd
  ? "https://atom-workflow-service.maersk-digital.net/"
  : isPreProd
  ? "https://atom-workflow-service.preprod.maersk-digital.net/"
  : isCdt
  ? "https://atom-workflow-service.cdt.maersk-digital.net/"
  : "https://atom-workflow-service.dev.maersk-digital.net/";

//ATOM GEN AI ENDPOINTS
const ATOM_GENAI = isProd
  ? "https://atomai-genai-summarization.maersk-digital.net/"
  : isPreProd
  ? "https://atomai-genai-summarization.cdt.maersk-digital.net/"
  : isCdt
  ? "https://atomai-genai-summarization.cdt.maersk-digital.net/"
  : "https://atomai-genai-summarization.dev.maersk-digital.net/";

export const oAuthEndPoint = isProd
  ? "https://atom-commons-service.maersk-digital.net/api/login"
  : isPreProd
  ? "https://atom-commons-service.preprod.maersk-digital.net/api/login"
  : isCdt
  ? "https://atom-commons-service.cdt.maersk-digital.net/api/login"
  : "https://atom-commons-service.dev.maersk-digital.net/api/login";

// Graph URL
export const graphMeEndpoint = "https://graph.microsoft.com/v1.0/me";

// Account Base URLS
export const getDisputeUsersEndpoint = `${ACCOUNT_BASE_URL}ms-graph/groups`;

//Surcharge Emails- from QSR End point
export const getEmailActivityContentFromQSREndPoint = (key, nextLink) =>
  `${ACCOUNT_BASE_URL}msGraph/searchEmail?key=${key}&skipToken=${nextLink}`;

export const getSurchargeEmailDetailsEndPoint = (id) =>
  `${ACCOUNT_BASE_URL}msGraph/getMailDetails?id=${id}`;

export const downloadSurchargeEmailEndpoint = (id) =>
  `${ACCOUNT_BASE_URL}msGraph/downloadMimeContent?id=${id}`;

// Dispute URLs
export const getDisputeResolutionRulesEndpoint = `${DISPUTE_BASE_URL}workflow/rules/resolution`;
export const getDisputeResolutionStageEndpoint = `${DISPUTE_BASE_URL}workflow/task/nextstage`;
export const getDisputeDetailsEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}`;
export const getDisputeResolutionEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}`;

export const updateDisputeBulkEndpoint = `${DISPUTE_BASE_URL}dispute/bulk`;
export const getStatusDisputeBulkEndpoint = `${DISPUTE_BASE_URL}dispute/bulk/response`;
export const getChargeCodeDataEndpoint = `${DISPUTE_BASE_URL}dispute/soa/lookup`;
export const getSapInvoiceDataEndpoint = `${DISPUTE_BASE_URL}dispute/soa/invoices`;
export const getDisputeTraceRetryEndpoint = `${DISPUTE_BASE_URL}workflow/task/`;
export const createDisputeEndpoint = `${DISPUTE_BASE_URL}dispute`;

//Fetch Country Details endpoint
export const getCountryDetailsEndPoint = `${DATA_BASE_URL}disputes-data/country-details`;

//Fetch Carrier Code EndPoint
export const getCarrierCodeDetailsEndPoint = `${DATA_BASE_URL}disputes-data/company-operator-details/operators`;

//Auto Allocation cases endpoints
export const autoAllocateCasesEndpoint = (apmId, numberOfCaseCount) =>
  `${DISPUTE_BASE_URL}dispute/allocate-cases?dispute-agent-apmid=${apmId}&number-of-cases=${numberOfCaseCount}`;

export const caseAllocationStatus = (apmId) =>
  `${DISPUTE_BASE_URL}dispute/case-allocation/status?dispute-agent-apmid=${apmId}`;

export const getDisputeInvoiceEndpoint = `${DISPUTE_BASE_URL}dispute`;

export const categoriesMenuItemEndpoint = (
  itemCategoryDescription,
  product,
  linOfBusiness
) =>
  `${ACCOUNT_BASE_URL}categories-menu-item?item-category-description=${itemCategoryDescription}&product=${product}&line-of-business=${linOfBusiness}`;
// Dispute Assignee URLs
export const getDisputeAssigneeEndpoint = `${DISPUTE_BASE_URL}workflow/task/claim`;

//Get Live Dashboard Endpoint
export const getLiveDashboardEndpoint = (
  view,
  countryName,
  areaName,
  reasonDescription,
  fromDate,
  toDate
) => `${DISPUTE_BASE_URL}disputes/live-dashboard?view=${view}&countryName=${countryName}&areaName=${areaName}&reason=${reasonDescription}&fromDate=${fromDate}&
toDate=${toDate}`;

//Get Live Dashboard Data by BulkId Endpoint
export const getLiveDashboardDataByBulkIdEndpoint = (bulkId) =>
  `${DISPUTE_BASE_URL}disputes/live-dashboard/${bulkId}`;

//Attachment api's
export const scanAttachmentsEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/scan/${ohpDisputeId}`;
export const uploadAttachmentsEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/upload/${ohpDisputeId}`;
export const scanStatusAttachmentsEndpoint = (documentId) =>
  `${DISPUTE_BASE_URL}dispute/status/${documentId}`;
// Dispute Data URL's
export const getShipmentDetailsEndpoint = (ohpDisputeId) =>
  `${DATA_BASE_URL}disputes-data/shipment/${ohpDisputeId}`;
export const disputeFieldLookupsEndpoint = `${DATA_BASE_URL}lookup`;
export const disputeFieldConstantsEndpoint = `${DATA_BASE_URL}constants`;

//Gam Data URL'S

export const getGamListEndpoint = (pageNo, pageSize) =>
  `${GAM_BASE_URL}v2/gam/search/filter?page_no=${pageNo}&page_size=${pageSize}`;
export const getGamDetailsEndpoint = (gamId, gamType) =>
  `${GAM_BASE_URL}v2/gam/${gamId}?gamType=${gamType}`;

export const getGamInfoForInvoiceNo = (pageOffset, pageSize, invoice_number) =>
  `${GAM_BASE_URL}v2/gam?pageSize=${pageSize}&pageOffset=${pageOffset}&gamChargeItems.billingDocumentNo=${invoice_number}&status=Pending review by Approver&status=Request clarification&status=Approved`;

export const initiateAutoGamCreate = () =>
  `${ATOM_WORKFLOW}workflow/publish/message`;
//Auto Resolution endpoints
export const getAutoResolutionDetailsEndpoint = (invoiceNumber) =>
  `${DATA_BASE_URL}disputes-data/resolution/suggest?invoice_number=${invoiceNumber}`;

// Sfdc & ISR api endpoints
export const getDisputeFromSfdcInvoiceEndpoint = (invoiceNumber) =>
  `${SFDC_BASE_URL}cm/case/dispute?invoice_number=${invoiceNumber}`;
export const getRelatedIsrFromSfdcInvoiceEndpoint = (invoiceNumber) =>
  `${SFDC_BASE_URL}cm/case/dispute/isr?invoice_number=${invoiceNumber}`;
export const getDisputeFromSfdcEndpoint = (sfdcCaseId) =>
  `${SFDC_BASE_URL}cm/case/dispute/${sfdcCaseId}`;
// export const getRelatedIsrFromSfdcEndpoint = (sfdcCaseId) =>
//   `${SFDC_BASE_URL}cm/case/dispute/isr/${sfdcCaseId}`;
export const getIsrDetailsEndpoint = (id) =>
  `${SFDC_BASE_URL}cm/case/dispute/isr/${id}`;
export const getAttachmentsFromSfdcEndpoint = (id) =>
  `${SFDC_BASE_URL}cm/case/${id}/attachment`;
export const downloadAttachmentSfdcEndpoint = (id) =>
  `${SFDC_BASE_URL}cm/case/attachment/${id}/download`;
export const createIsrEndpoint = () => `${SFDC_BASE_URL}cm/case/dispute/isr`;
export const updateIsrEndpoint = (id) =>
  `${SFDC_BASE_URL}cm/case/dispute/isr/${id}`;
export const getEmailActivitiesEndpoint = (id) =>
  `${SFDC_BASE_URL}cm/case/${id}/email`;
export const getEmailActivityContentEndpoint = (id) =>
  `${SFDC_BASE_URL}cm/case/email/${id}`;
export const getCountryListEndpoint = (searchTerm) =>
  `${DISPUTE_BASE_LOCATION}?${searchTerm}`;

// Dispute Filter URls
export const getFiltersEndPoint = `${ACCOUNT_BASE_URL}v1/product/${product_id}/user-preference/filter-preference`;
export const createFilterPreferenceEndPoint = `${ACCOUNT_BASE_URL}v1/product/${product_id}/user-preference/filter-preference`;
export const updatedFilterPreferenceEndPoint = `${ACCOUNT_BASE_URL}v1/product/${product_id}/user-preference/filter-preference`;

export const getUserListEndpoint = `${ACCOUNT_BASE_URL}ms-graph/users/search`;
export const getUserListsEndpoint = `${ACCOUNT_BASE_URL}ms-graph/users`;

export const createShareFilterEndpoint = (productId) =>
  `${ACCOUNT_BASE_URL}v1/product/${productId}/user-preference/filter-preference/share`;

export const getShareFilterEndpoint = (productId, shareFilterId) =>
  `${ACCOUNT_BASE_URL}v1/product/${productId}/user-preference/filter-preference/share/${shareFilterId}`;

export const triggerShareFilterEmailEndpoint = (productId) =>
  `${ACCOUNT_BASE_URL}v1/product/${productId}/user-preference/filter-preference/share/send-email`;

export const getDisputeListEndpoint = `${DISPUTE_BASE_URL}dispute/search/filter`;

export const getDisputeFacetsEndpoint = (property_id) =>
  `${DISPUTE_BASE_URL}dispute/search/filter/facets/${property_id}`;

export const getVoiceDisputesEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/voice`;

export const createVoiceDisputeEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/voice`;

export const updateVoiceDisputeEndpoint = (ohpDisputeId, voiceDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/voice/${voiceDisputeId}`;

export const deleteVoiceDisputeEndpoint = (ohpDisputeId, voiceDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/voice/${voiceDisputeId}`;

export const updateContactDetailsEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}`;

export const updateSummaryActionedEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}`;

export const createBulkVoiceDisputeEndpoint = `${DISPUTE_BASE_URL}dispute/voice/bulk`;

export const getDisputeHistoryEndpoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/audit/history/v2/${ohpDisputeId}`;

export const validateBulkDisputeEndPoint = `${DISPUTE_BASE_URL}dispute/resolution-delay-reason/bulk`;

export const fetchCommentsEndpoint = (ohpDisputeId, pageSize, pageNo) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/comment?page_size=${pageSize}&page_no=${pageNo}`;

// SFDC Index APIs
export const getSFDCIndexListEndPoint = `${DISPUTE_BASE_URL}sfdcindex`;
export const bulkDisputeEndPoint = `${DISPUTE_BASE_URL}dispute/bulk`;

// Tender update APIs
export const updateTenderEndPoint = (ohpDisputeId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/tender`;
export const updateBulkTenderEndPoint = `${DISPUTE_BASE_URL}dispute/tender/bulk`;

//Comments Api
export const saveCommentsEndpoint = (ohpDisputeId, isExternal) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/comment?is_external=${
    isExternal || false
  }`;

export const updateSummarizationCommentsEndpoint = (ohpDisputeId, commentId) =>
  `${DISPUTE_BASE_URL}dispute/${ohpDisputeId}/comment/${commentId}/summary`;

export const saveBulkCommentsEndpoint = (isExternal) =>
  `${DISPUTE_BASE_URL}dispute/comment/bulk?is_external=${isExternal || false}`;
export const saveBulkSFDCCommentsEndpoint = `${DISPUTE_BASE_URL}dispute/comment`;

export const createDisputeArchivedEndpoint = `${DISPUTE_BASE_URL}dispute/archived-invoice/bulk`;

export const getSfdcEmailListEndpoint = (tpDocNumber) =>
  `${SFDC_BASE_URL}cm/case/dispute/booking/${tpDocNumber}`;

export const saveGamRequestDetailsEndpoint = () =>
  `${DISPUTE_BASE_URL}disputes/gam-request`;

//create user profile
export const createUserEndPoint = `${DATA_BASE_URL}disputes-data/user-profile`;
//edit user profile
export const editUserProfileEndPoint = (userApmId) =>
  `${DATA_BASE_URL}disputes-data/user-profile/${userApmId}`;
//delete user profile
export const deleteUserProfileEndPoint = (userApmId) =>
  `${DATA_BASE_URL}disputes-data/user-profile/${userApmId}`;
//fetch user details
export const getUserEndPoint = (userApmId) =>
  `${DATA_BASE_URL}disputes-data/user-profile/${userApmId}`;
//fetch all users
export const getAllUserDetailsEndPoint = `${DATA_BASE_URL}disputes-data/user-profile/filter`;

//Atom Gen AI Endpoint
export const loadVectorDetailsEndpoint = `${ATOM_GENAI}api/v1/LoadVector`;
export const rephraseCommentEndpoint = `${ATOM_GENAI}api/v1/rePhrase`;
